// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect, useRef } from 'react';

function TopicSelectionModal({ topics, onSelect, defaultTopic, trendingTopics }) {
    const [selected, setSelected] = useState(defaultTopic || (topics[0] && topics[0].slug) || '');
    const [isAnimating, setIsAnimating] = useState(false);
    const overlayRef = useRef(null);

    useEffect(() => {
        // Animate in
        setIsAnimating(true);
    }, []);

    var handleSelect = function() {
        if (!selected) return;
        var topic = topics.find(function(t) { return t.slug === selected; });
        if (topic) onSelect(topic);
    };

    var handleKeyDown = function(e) {
        if (e.key === 'Enter') handleSelect();
        if (e.key === 'Escape') handleSelect(); // dismiss with default
    };

    // Group topics by category
    var grouped = {};
    topics.forEach(function(t) {
        var cat = t.category || 'General';
        if (!grouped[cat]) grouped[cat] = [];
        grouped[cat].push(t);
    });

    return (
        <div className={`lw-tsm-overlay ${isAnimating ? 'lw-tsm-overlay--visible' : ''}`} ref={overlayRef}>
            <div className="lw-tsm-card" onKeyDown={handleKeyDown}>
                <div className="lw-tsm-icon">&#x1F4DA;</div>
                <h2 className="lw-tsm-title">What do you want to learn today?</h2>
                <p className="lw-tsm-sub">Select a topic to generate your personalized AI curriculum</p>

                {trendingTopics && trendingTopics.length > 0 && (
                    <div className="lw-tsm-trending">
                        <div className="lw-tsm-trending-label">Trending Now</div>
                        <div className="lw-tsm-trending-chips">
                            {trendingTopics.map(function(t) {
                                return (
                                    <button
                                        key={t.slug}
                                        className={'lw-tsm-trending-chip' + (selected === t.slug ? ' lw-tsm-trending-chip--active' : '')}
                                        onClick={function() { setSelected(t.slug); }}
                                        title={t.sessionCount + ' students studying this week'}
                                    >
                                        <span className="lw-tsm-trending-fire">&#x1F525;</span>
                                        <span>{t.displayName}</span>
                                        <span className="lw-tsm-trending-count">{t.sessionCount}</span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                )}

                <div className="lw-tsm-select-wrap">
                    <select
                        className="lw-tsm-select"
                        value={selected}
                        onChange={function(e) { setSelected(e.target.value); }}
                        autoFocus
                    >
                        {Object.keys(grouped).map(function(cat) {
                            return (
                                <optgroup key={cat} label={cat}>
                                    {grouped[cat].map(function(t) {
                                        return (
                                            <option key={t.slug} value={t.slug}>
                                                {t.displayName}
                                            </option>
                                        );
                                    })}
                                </optgroup>
                            );
                        })}
                    </select>
                    <i className="lw-tsm-select-arrow">▾</i>
                </div>

                {selected && (function() {
                    var topic = topics.find(function(t) { return t.slug === selected; });
                    return topic ? (
                        <div className="lw-tsm-preview">
                            <span className="lw-tsm-preview-label">Selected:</span>
                            <span className="lw-tsm-preview-topic">{topic.displayName}</span>
                            <span className="lw-tsm-preview-cat">{topic.category}</span>
                        </div>
                    ) : null;
                })()}

                <button
                    className="lw-tsm-btn"
                    onClick={handleSelect}
                    disabled={!selected}
                >
                    <span>Start Learning</span>
                    <span className="lw-tsm-btn-arrow">→</span>
                </button>

                <p className="lw-tsm-hint">Your AI curriculum will be auto-generated for this topic</p>
            </div>
        </div>
    );
}

export default TopicSelectionModal;
